import { createFromIconfontCN } from '@ant-design/icons';
import IconWrapper from 'component/IconWrapper';

const IconFont = createFromIconfontCN({
  scriptUrl: window.location.origin + '/public/font_2352304_273uf3vklhj.js'
});

export default IconWrapper(IconFont);
